function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 0C8.50759 0 0 8.50759 0 19C0 29.4924 8.50759 38 19 38C29.4924 38 38 29.4924 38 19C38 8.50759 29.4924 0 19 0ZM19 34.7768C10.2888 34.7768 3.22321 27.7112 3.22321 19C3.22321 10.2888 10.2888 3.22321 19 3.22321C27.7112 3.22321 34.7768 10.2888 34.7768 19C34.7768 27.7112 27.7112 34.7768 19 34.7768Z",
  fill: "currentcolor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4093 24.3692L20.3616 19.9966V9.49993C20.3616 9.31332 20.2089 9.16064 20.0223 9.16064H17.9824C17.7957 9.16064 17.6431 9.31332 17.6431 9.49993V21.1799C17.6431 21.2902 17.694 21.3919 17.783 21.4556L24.7977 26.5703C24.9504 26.6806 25.1625 26.6467 25.2727 26.4982L26.4857 24.8442C26.5959 24.6873 26.562 24.4752 26.4093 24.3692Z",
  fill: "currentcolor"
});

const SvgLoading = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 38 38",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading.2d07bdc9.svg";
export { ForwardRef as ReactComponent };